import { Row } from 'react-bootstrap';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import CountrySelectField from 'components/forms/countrySelectField/CountrySelectField';
import TextField from 'components/forms/textField/TextField';
import StateSelectField from 'components/forms/stateSelectField/StateSelectField';
import { CountryCode } from 'models/Country';
import { FormSectionColumn } from '../../../common/Common.styles';
import { PropertySettingsMainTabFormValues } from '../../PropertySettingsMainTab.schema';
import usePropertySettingsInitData from '../../../usePropertySettingsInitData';
import { PropertyAddressCollapseStyled } from './PropertyAddress.styles';

const PropertyAddress = () => {
  const { uid: propertyUid } = useParams();
  const { property } = usePropertySettingsInitData();
  const { t } = useTranslation();
  const {
    // @ts-expect-error TS2339 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    propertyAddress: { countryCode },
  } = useWatch<PropertySettingsMainTabFormValues>();

  const isEditMode = !!propertyUid;
  const isStateRequired = countryCode === CountryCode.US;

  return (
    <PropertyAddressCollapseStyled
      data-testid="property-address"
      defaultExpanded
      label={t('pageProperty.mainSettings.propertyAddress.sectionTitle', {
        context: property?.businessType,
      })}
      variant="card"
    >
      <fieldset>
        <Row>
          <FormSectionColumn>
            <TextField
              label={t(
                'pageProperty.mainSettings.propertyAddress.addressLine1',
              )}
              name="propertyAddress.addressLine1"
              colSmInput={7}
              colSmLabel={5}
              required
            />
            <TextField
              label={t(
                'pageProperty.mainSettings.propertyAddress.addressLine2',
              )}
              name="propertyAddress.addressLine2"
              colSmInput={7}
              colSmLabel={5}
            />
            <TextField
              label={t('pageProperty.mainSettings.propertyAddress.city')}
              name="propertyAddress.city"
              colSmInput={7}
              colSmLabel={5}
              required
            />
            <TextField
              label={t('pageProperty.mainSettings.propertyAddress.zipCode')}
              name="propertyAddress.zipCode"
              colSmInput={7}
              colSmLabel={5}
              required
            />
          </FormSectionColumn>
          <FormSectionColumn>
            <StateSelectField
              countryCode={countryCode}
              defaultUsState="AL"
              label={t('pageProperty.mainSettings.propertyAddress.state')}
              name="propertyAddress.state"
              colSmInput={7}
              colSmLabel={5}
              required={isStateRequired}
            />
            <CountrySelectField
              label={t('pageProperty.mainSettings.propertyAddress.countryCode')}
              name="propertyAddress.countryCode"
              colSmInput={7}
              colSmLabel={5}
              required
            />
            {isEditMode && (
              <>
                <TextField
                  label={t(
                    'pageProperty.mainSettings.propertyAddress.latitude',
                  )}
                  name="propertyAddress.latitude"
                  colSmInput={7}
                  colSmLabel={5}
                  rightTooltip={t(
                    'pageProperty.mainSettings.propertyAddress.coordinatesTooltip',
                  )}
                />
                <TextField
                  label={t(
                    'pageProperty.mainSettings.propertyAddress.longitude',
                  )}
                  name="propertyAddress.longitude"
                  colSmInput={7}
                  colSmLabel={5}
                  rightTooltip={t(
                    'pageProperty.mainSettings.propertyAddress.coordinatesTooltip',
                  )}
                />
              </>
            )}
          </FormSectionColumn>
        </Row>
      </fieldset>
    </PropertyAddressCollapseStyled>
  );
};

export default PropertyAddress;
